import React from 'react';

const ArticlesListHeader = () => {
  return (
    <div className="max-w-2xl mx-auto text-center">
      <h2
        id="articles-list-title"
        className="text-3xl font-bold tracking-tight text-gray-900 sm:text-4xl"
      >
        Todos os artigos
      </h2>
      <p className="mt-4 text-lg text-gray-600">
        Estou organizando estes temas agora. Em breve entram os textos completos.
      </p>
    </div>
  );
};

export default ArticlesListHeader;
